import { graphQlClient } from "lib/graphql-client.js";
import Layout from "components/Layout";
import MapPage from "components/MapPage/MapPage";

import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";
import { fetchDestinationsByRegion } from "lib/api/strapi-destinations";
export default function Map({ seo, destinationData, layoutData }) {
  const SEO = seo;

  return (
    <Layout showEmailSignup={false} seo={SEO} layoutData={layoutData}>
      <div className={`variable-container-flush`}>
        <MapPage data={{ destinations: destinationData }} />
      </div>
    </Layout>
  );
}

export async function getStaticProps() {
  const { gql } = await import("@apollo/client");
  const strapiApolloClient = graphQlClient();

  const destinationData = await fetchDestinationsByRegion({
    regions: [
      "africa",
      "asia",
      "caribbean",
      "central-america",
      "europe",
      "middle-east",
      "north-america",
      "oceania",
      "south-america",
    ],
  });

  const seoData = await strapiApolloClient.query({
    query: gql`
      query MapPageQuery {
        mapPage {
          data {
            attributes {
              search_engine_optimization {
                metaTitle
                metaDescription
                metaMedia {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  });

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();
  return {
    props: {
      destinationData,
      seo: seoData.data.mapPage.data.attributes.search_engine_optimization,
      layoutData: layoutData,
    },
  };
}
